import { useStore } from '@/store';

export default defineNuxtPlugin(nuxt => {
  const store = useStore(nuxt.$pinia);

  addRouteMiddleware('my-middleware', (to) => {
    // Si hay un idioma explícito en la URL, siempre manda
    if (to.params?.lang) {
      store.setIdioma(to.params.lang)
    } else if (store.languages && store.languages.length > 0) {
      // Si estamos en la raíz y ya conocemos los idiomas, aseguramos que el idioma 
      // de la tienda coincida con el primero de la lista (el predeterminado).
      const firstLang = store.languages[0].Language;
      if (store.idioma !== firstLang) {
        store.setIdioma(firstLang);
      }
    }
    
    // Si store.languages es null (carga inicial), no hacemos nada aquí 
    // y dejamos que initNotaria en app.vue decida el idioma tras cargar el JSON.
    
    console.log('Middleware - Idioma actual:', store.idioma)
  }, { global: true });
});

// for non-global middleware use this:


// addRouteMiddleware('named-test', (to, from) => {
//   //console.log('this named middleware was added in a plugin')
// })

